import { ExperienceTabForm } from './types'

export const DEFAULT_VALUES: ExperienceTabForm = {
  areaatuacao: '',
  moduloatuacao: '',
  nivel: '',
  projetos_executados: '',
  valor_hora: '',
}
